import { mapGetters, mapMutations } from 'vuex'

var myMixin = {
  data() {
    return {
      active: '',
      query: {
        category_id: '',
        attributes: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'category'
    ]),
    attributes() {
      return this.$route.query.attributes
    }
  },
  watch: {
    category: {
      handler(n) {
        this.init()
      },
      deep: true
    }

  },
  created() {
    this.init()
  },
  methods: {
    ...mapMutations('position', ['SET_CATEGORY_TITLE']),
    async init() {
      const n = this.$route.query
      this.active = this.category.length ? this.category[0].name : ''
      if (n && n.category_id) {
        this.onChange({
          id: n.category_id,
          name: n.title
        })
      }
    },
    onChange(item) {
      this.query = {
        category_id: item.id,
        attributes: this.attributes
      }
      this.active = item.name
      this.SET_CATEGORY_TITLE({ name: item.name, id: item.id })
      // this.GET_LIST(this.query)
    }
  }
}

export default myMixin
